import { Keys } from './keys';
export function detectKeyboardNavigation() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;

  function setKeyboardNavigationOff() {
    document.body.classList.remove('ud-keyboard-navigation-in-use');
    document.body.addEventListener('keydown', setKeyboardNavigationOn);
    document.body.removeEventListener('mousedown', setKeyboardNavigationOff);
  }

  function setKeyboardNavigationOn(event) {
    if (event.keyCode === Keys.TAB) {
      document.body.classList.add('ud-keyboard-navigation-in-use');
      document.body.removeEventListener('keydown', setKeyboardNavigationOn);
      document.body.addEventListener('mousedown', setKeyboardNavigationOff);
    }
  }

  setKeyboardNavigationOff();
}
//# sourceMappingURL=detect-keyboard-navigation.js.map